import React from 'react'
import { getRequirementDisplayData, isCompleteStatus, isLockedStatus } from './utils'
import { buildInfoUrl } from './utils/urlUtils'
import MilestoneActionLinks from './MilestoneActionLinks'
import LockIconSvg from '../../../assets/icons/icon-lock-status.svg'
import {
  MilestoneCard,
  MilestoneInfoBanner,
  MilestoneInfoText,
  MilestoneHeader,
  MilestoneTitle,
  StatusBadgeSmall,
  StatusBadgeCheckmark,
  StatusBadgeLock,
  StatusBadgeText,
  MilestoneDescription,
  TextButton
} from './Styles/ProgressTracker.styles'

const IncompletePATRequirementCard = ({ requirement, activeLevel }) => {
  const displayData = getRequirementDisplayData(activeLevel, requirement)
  const isComplete = isCompleteStatus(requirement.status)
  const isLocked = isLockedStatus(requirement.status)

  return (
    <MilestoneCard key={requirement.id} hasWarning={true}>
      <MilestoneInfoBanner>
        <MilestoneInfoText>
          A passing score is needed before enrolling as a PGA Member.{' '}
          {displayData.infoLinkText && displayData.infoLinkUrl && (
            <TextButton
              as="a"
              href={buildInfoUrl(displayData.infoLinkUrl)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {displayData.infoLinkText}
            </TextButton>
          )}
        </MilestoneInfoText>
      </MilestoneInfoBanner>
      <MilestoneHeader>
        <MilestoneTitle>{displayData.name}</MilestoneTitle>
        <StatusBadgeSmall
          backgroundColor={displayData.backgroundColor}
        >
          {isComplete && <StatusBadgeCheckmark color={displayData.color} />}
          {isLocked && <StatusBadgeLock src={LockIconSvg} alt="Locked" />}
          <StatusBadgeText
            textColor={displayData.color}
          >
            {displayData.label}
          </StatusBadgeText>
        </StatusBadgeSmall>
      </MilestoneHeader>
      <MilestoneDescription>
        Congratulations, you have qualifying scores and can advance to Level 1. You will still need to pass the PAT in order to enroll as a PGA of America Professional by the end of Level 3.
      </MilestoneDescription>
      <MilestoneActionLinks
        displayData={displayData}
        requirementStatus={requirement.status}
      />
    </MilestoneCard>
  )
}

export default IncompletePATRequirementCard
